import types from 'constants/PaymentConstants';
import Immutable from 'immutable';

const initialState = Immutable.fromJS({
  typeList: [],
  labourPayment: [],
  paymentList: [],
  totalPrice: 0
});

export default function(state = initialState, action) {
	switch (action.type) {
		case types.REFRESH_PAYMENT_TYPE_LIST:
      return state.set('typeList', Immutable.fromJS(action.typeList))

    case types.UPDATE_PAYMENT_TYPE_NAME:
      return state.setIn(['typeList', state.get('typeList').findIndex((type) => type.get('id') === action.id), 'name'],
        action.name
      )

    case types.DELETE_PAYMENT_TYPE:
      return state.deleteIn(['typeList', state.get('typeList').findIndex((type) => type.get('id') === action.id)])

    case types.ADD_PAYMENT_TYPE:
      return state.updateIn(['typeList'], list => list.push(Immutable.fromJS({
        id: action.id,
        name: action.name
      })))

    case types.REFRESH_PAYMENT_LIST:
      return state.set('labourPayment', Immutable.fromJS(action.labour))
                  .set('paymentList', Immutable.fromJS(action.paymentList))
                  .set('totalPrice', Immutable.fromJS(action.totalPrice))

    case types.UPDATE_TOTAL_PRICE:
      return state.set('totalPrice', Immutable.fromJS(action.totalPrice))

    case types.ADD_PAYMENT:
      let typeID = parseInt(action.paymentType, 10 )
      let typeIndex = state.get('typeList').findIndex( type => type.get('id') === typeID)
      let cate = state.getIn(['typeList', typeIndex, 'name'])
      let cateIndex = state.get('paymentList').findIndex( payments => payments.get('type') === cate)

      return cateIndex < 0
              ? state.updateIn(['paymentList'], list => list.push(Immutable.fromJS({
                  type: cate,
                  payments: [
                    {
                      id: action.id,
                      amount: action.amount,
                      notes: action.notes 
                    }
                  ]
                })))
              : state.updateIn(['paymentList', cateIndex, 'payments'], list => list.push(Immutable.fromJS({
                  id: action.id,
                  amount: action.amount,
                  notes: action.notes
                })))
    
    case types.DELETE_PAYMENT:
      let cateIndexForDel = state.get('paymentList').findIndex( payments => payments.get('type') === action.cate)
      let paymentIndexForDel = state.getIn(['paymentList', cateIndexForDel, 'payments']).findIndex(payment => payment.get('id') === action.id)

      return state.deleteIn(['paymentList', cateIndexForDel, 'payments', paymentIndexForDel]) 

    case types.UPDATE_PAYMENT:
      let cateIndexForEdit = state.get('paymentList').findIndex( payments => payments.get('type') === action.cate)
      let paymentIndexForEdit = state.getIn(['paymentList', cateIndexForEdit, 'payments']).findIndex(payment => payment.get('id') === action.id)

      return state.setIn(['paymentList', cateIndexForEdit, 'payments', paymentIndexForEdit, 'amount'], action.amount)
                  .setIn(['paymentList', cateIndexForEdit, 'payments', paymentIndexForEdit, 'notes'], action.notes)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/Payment.js